import { render } from "./stockRefs.vue?vue&type=template&id=5170425a"
import script from "./stockRefs.vue?vue&type=script&lang=ts"
export * from "./stockRefs.vue?vue&type=script&lang=ts"
script.render = render

export default script